import EventsInterfaceV1 from './EventsInterfaceV1';
import { EventsInterfaceType } from '@clientos/types';

export { createNoopEventInterface } from './NoopInterface';

let eventsInterfaceV1: EventsInterfaceV1;

export function getEventsInterfaceV1(): EventsInterfaceType {
  return eventsInterfaceV1.getInterface();
}

export function clearEventsInterfaceSingleton(): void {
  eventsInterfaceV1 = undefined;
}

export default async function initializeEventsInterfaceV1(): Promise<EventsInterfaceType> {
  if (eventsInterfaceV1) return eventsInterfaceV1.getInterface();
  eventsInterfaceV1 = new EventsInterfaceV1();

  return eventsInterfaceV1.getInterface();
}
